const BASE_URL = process.env.VUE_APP_API_URL

let storeInstance = null

function getStore() {
  if (!storeInstance) {
    storeInstance = require('@/store').default
  }
  return storeInstance
}

async function handleResponse(response, retryRequest) {
  const data = await response.json().catch(() => ({}))

  if (!response.ok) {
    if (response.status === 401 && retryRequest) {
      try {
        const store = getStore()
        await store.dispatch('auth/refresh')
        return retryRequest()
      } catch (refreshError) {
        localStorage.removeItem('token')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('user')
        const store = getStore()
        store.commit('auth/CLEAR_AUTH')
        store.dispatch('notification/showError', 'Session expired. Please login again.')
        window.location.href = '/'
        throw new Error('Session expired')
      }
    }

    const message =
      data?.error?.message ||
      data?.message ||
      'Something went wrong'

    getStore().dispatch('notification/showError', message)
    throw new Error(message)
  }

  return data
}

function buildHeaders(authorized = false) {
  const headers = {
    'Content-Type': 'application/json'
  }

  if (authorized) {
    const token = localStorage.getItem('token')
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }
  }

  return headers
}

export default {
  get(url, options = {}) {
    const makeRequest = () =>
      fetch(BASE_URL + url, {
        method: 'GET',
        headers: buildHeaders(options.authorized)
      }).then(response =>
        handleResponse(response, options.authorized ? makeRequest : null)
      )

    return makeRequest()
  },

  post(url, body, options = {}) {
    const makeRequest = () =>
      fetch(BASE_URL + url, {
        method: 'POST',
        headers: buildHeaders(options.authorized),
        body: JSON.stringify(body)
      }).then(response =>
        handleResponse(response, options.authorized ? makeRequest : null)
      )

    return makeRequest()
  },

  put(url, body, options = {}) {
    const makeRequest = () =>
      fetch(BASE_URL + url, {
        method: 'PUT',
        headers: buildHeaders(options.authorized),
        body: JSON.stringify(body)
      }).then(response =>
        handleResponse(response, options.authorized ? makeRequest : null)
      )

    return makeRequest()
  },

  delete(url, options = {}) {
    const makeRequest = () =>
      fetch(BASE_URL + url, {
        method: 'DELETE',
        headers: buildHeaders(options.authorized)
      }).then(response =>
        handleResponse(response, options.authorized ? makeRequest : null)
      )

    return makeRequest()
  },

  postFormData(url, formData, options = {}) {
    const headers = {}
    if (options.authorized) {
      const token = localStorage.getItem('token')
      if (token) headers.Authorization = `Bearer ${token}`
    }

    const makeRequest = () =>
      fetch(BASE_URL + url, {
        method: 'POST',
        headers,
        body: formData
      }).then(response =>
        handleResponse(response, options.authorized ? makeRequest : null)
      )

    return makeRequest()
  }
}
